var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:['fddform-input-list-row', { 'input-hover': _vm.hoverSelect }],attrs:{"title":_vm.currentLabel},on:{"click":function($event){$event.stopPropagation();return _vm.optionClick.apply(null, arguments)}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.currentLabel))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }